import Typography from '@components/v2/ui/Typography/Typography';
import { TypographyVariant } from '@mui/material/styles';

interface ExpandableTitleProps {
  title?: string;
  variant: TypographyVariant;
  className: string;
  lock?: boolean;
}

const ExpandableTitle = ({ title, variant, className, lock }: ExpandableTitleProps) => (
  <Typography variant={variant} className={className} sx={{ cursor: lock ? 'auto' : 'pointer' }}>
    {title}
  </Typography>
);

export default ExpandableTitle;
